
import CommissionTable from "../../../ui/Tables/CommissionTable";
import { useLocation, useParams } from "react-router-dom";

const UserCommissions = ({ data }) => {

    const location = useLocation();
    const { userId } = useParams();
    const userData = location.state || data || { id: userId };

    return (
        <CommissionTable data={userData} />
    );
}


export default UserCommissions;
